module.exports = __webpack_public_path__ + "static/media/CardCaldasNovas2.67d73db0.jpg";